import {
  Box,
  Button,
  Dialog,
  Grid,
  IconButton,
  Typography,
} from '@mui/material';
import { styled } from '@mui/material/styles';
import clsx from 'clsx';
import React from 'react';

import ClearIcon from 'common/shared-ui/src/icons/ClearIcon';

import { useTranslation } from '../../../../utils/getLocalString';

// Original class: modalRoot
const StyledModalRoot = styled(Dialog)(theme => ({
  '& .MuiDialog-container': {
    padding: '84px 0 20px 0',
  },

  '& .MuiPaper-root.MuiDialog-paper': {
    overflow: 'visible',
    padding: '20px',
    width: '362px',
    backgroundColor: '#fff',
    borderRadius: '16px',
    margin: 0,
    maxHeight: '100%',
  },
}));

type Props = {
  readonly simple: boolean;
  readonly onlyCancel: boolean;
  readonly isWarningModalOpen: boolean;
  readonly title: string;
  readonly issue: unknown;
  readonly handleToggle: () => void;
  readonly closeWarningModal: () => void;
};

const WarningModal: React.FC<Props> = props => {
  const {
    title,
    issue,
    simple,
    onlyCancel,
    isWarningModalOpen,
    closeWarningModal,
    handleToggle,
  } = props;

  const getLocalString = useTranslation();
  return (
    <StyledModalRoot open={isWarningModalOpen} disableRestoreFocus>
      <Grid container direction='column'>
        <Grid
          container
          sx={{
            justifyContent: 'flex-end',
          }}
        >
          <IconButton
            disableRipple
            onClick={closeWarningModal}
            value='close'
            sx={{ padding: issue ? 0 : '8px' }}
          >
            <Box
              sx={{
                width: 24,
                height: 24,
              }}
            >
              <ClearIcon width={24} height={24} viewBox='0 0 24 24' />
            </Box>
          </IconButton>
        </Grid>
        <Grid
          container
          direction='column'
          sx={{
            overflow: 'hidden',
            flexWrap: 'nowrap',
            marginTop: '40px',
          }}
        >
          <Typography
            variant={simple ? 'h1' : 'h3'}
            sx={{
              textAlign: 'center',
              fontWeight: simple ? '700' : '600',
              color: '#082253',
            }}
          >
            {title}
          </Typography>
        </Grid>
        <Grid
          container
          sx={{
            justifyContent: 'center',
            marginTop: '40px',
          }}
        >
          {!onlyCancel && (
            <>
              <Button
                disableRipple
                className={clsx('defaultButton', 'primary')}
                value='save'
                onClick={handleToggle}
                sx={{ minWidth: '100px' }}
              >
                <Typography
                  variant='h4'
                  sx={{
                    fontWeight: 700,
                  }}
                >
                  {getLocalString('labels', 'yes')}
                </Typography>
              </Button>
              <Button
                disableRipple
                className={clsx('defaultButton', 'secondary')}
                value='delete'
                onClick={handleToggle}
                sx={{ marginLeft: '4px', minWidth: '100px' }}
              >
                <Typography
                  variant='h4'
                  sx={{
                    fontWeight: 700,
                  }}
                >
                  {getLocalString('labels', 'no')}
                </Typography>
              </Button>
            </>
          )}
          {simple && (
            <Button
              disableRipple
              variant='defaultBluePrimary'
              value='cancel'
              onClick={handleToggle}
              sx={{ minWidth: '100px' }}
            >
              <Typography
                variant='h4'
                sx={{
                  fontWeight: 700,
                }}
              >
                {getLocalString('buttons', 'cancel')}
              </Typography>
            </Button>
          )}
        </Grid>
      </Grid>
    </StyledModalRoot>
  );
};

export default WarningModal;
